import { Link } from "react-router-dom";
import React, {useEffect, useRef, useState} from 'react';
import Highlighter from 'react-highlight-words';
// import {TokensDto} from '@gtpl/shared-models/hrms';

import moment from "moment";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { Button, Card, Col, Divider, Drawer, Input, Popconfirm, Row, Switch, Table, Tag, Tooltip } from "antd";
import {CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EditOutlined, SearchOutlined, AlertTwoTone} from '@ant-design/icons';

import { ColumnProps } from "antd/lib/table";
import { FreebiesMappingConsumptionService } from "@gtpl/shared-services/canteen-management";
import { EmployeeFreebiesAssignRequest } from "@gtpl/shared-models/canteen-management";
import EmployeeTokens from "./employee-tokens";

export interface EmployeeTokensGridProps{

}

export function EmployeeTokensGrid(
    props:EmployeeTokensGridProps

){
    const searchInput = useRef(null);
    const [page, setPage] = React.useState(1);
    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchText, setSearchText] = useState(''); 
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [selectedToken, setSelectedToken] = useState<any>(undefined);
    const [tokensData , setTokensData] = useState<any[]>([]);
    
    const tokensService = new FreebiesMappingConsumptionService();

    useEffect(() => {
        getAllTokens();
      },[]);

    const getAllTokens=()=>{
        tokensService.getAllEmployeeFreebies().then(res => {
            if(res.status){
              setTokensData(res.data);
            }else{
                AlertMessages.getErrorMessage(res.internalMessage);
                }
              }).catch(err => {
                AlertMessages.getErrorMessage(err.message);
                setTokensData([]);
              })
            }
          console.log(selectedToken)
    

    /**
   * 
   * @param tokensData 
   */
   const deleteEmployeeToken = (tokensData:EmployeeFreebiesAssignRequest) => {
    console.log(tokensData)
    tokensData.isActive=tokensData.isActive?false:true;
     tokensService.ActivateorDeactivateToken(tokensData).then(res => { console.log(res);
      if (res.status) {
        getAllTokens();
        AlertMessages.getSuccessMessage('Success');
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
      console.log(err)
    })
  }

  /**
     * 
     * @param variantData 
     */
   const updateEmployeeToken = (tokensData: EmployeeFreebiesAssignRequest) => {
    tokensService.updateEmployeeFreebies(tokensData).then(res => { console.log(res);
      if (res.status) {
        AlertMessages.getSuccessMessage('Updated Successfully');
        getAllTokens();
        setDrawerVisible(false);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });

  /**
 * 
 * @param selectedKeys 
 * @param confirm 
 * @param dataIndex 
 */
function handleSearch(selectedKeys, confirm, dataIndex) {
  confirm();
  setSearchText(selectedKeys[0]);
  setSearchedColumn(dataIndex);
};

function handleReset(clearFilters) {
  clearFilters();
  setSearchText('');
};

  //drawer related
  const closeDrawer=()=>{
    setDrawerVisible(false);
  }

  //TO open the form for updation
//   const openFormWithData=(viewData: TokensDto)=>{
//     setDrawerVisible(true);
//     viewData.complaintRaisedDate=moment(viewData.complaintRaisedDate)
//     setSelectedToken(viewData);
//     console.log(selectedToken)
//     console.log('selectedToken')
//   }

  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    
    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
      // responsive: ['lg'],
      sorter: (a, b) => a.employeeCode.length - b.employeeCode.length,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('employeeCode')
    },
    {
      title: 'Freebie Code',
      dataIndex: 'freebieCode',
      // responsive: ['lg'],
      sorter: (a, b) => a.freebieCode.length - b.freebieCode.length,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('freebieCode')
    },
    {
        title: 'Year',
        dataIndex: 'year',
        // responsive: ['lg'],
        sorter: (a, b) => a.year.length - b.year.length,
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('year')
      },
      {
        title: 'Month',
        dataIndex: 'month',
        // responsive: ['lg'],
        sorter: (a, b) => a.month.length - b.month.length,
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('month')
      },
      {
        title: 'Total Tokens',
        dataIndex: 'totalTokens',
        // responsive: ['lg'],
        sorter: (a, b) => a.totalTokens.length - b.totalTokens.length,
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('totalTokens')
      },
      {
        title: 'Available Tokens',
        dataIndex: 'availableTokens',
        // responsive: ['lg'],
        sorter: (a, b) => a.availableTokens.length - b.availableTokens.length,
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('availableTokens')
      },
      {
        title: 'Max Consumption Per Day',
        dataIndex: 'maxConsumptionPerDay',
        // responsive: ['lg'],
        sorter: (a, b) => a.maxConsumptionPerDay.length - b.maxConsumptionPerDay.length,
        sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('maxConsumptionPerDay')
      },
      
    
   
      {
        title: 'Status',
        dataIndex: 'isActive',
        align:'center',
        width: '170px',
        render: (isActive, rowData) => (
          <>
            {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
          </>
        ),
        filters: [
          {
            text: 'Active',
            value: true,
          },
          {
            text: 'InActive',
            value: false,
          },
        ],
        filterMultiple: false,
        onFilter: (value, record) => 
        {
          // === is not work
          return record.isActive === value;
        },
        
      },
    {
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>      
          <Tooltip placement="top" title='Edit'>     
          <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
            onClick={() => {
              if (rowData.isActive) {
                 openFormWithData(rowData);
              } else {
                AlertMessages.getErrorMessage('You Cannot Edit Deactivated Id Proof Type');
              }
            }}
            style={{ color: '#1890ff', fontSize: '14px' }}
          />
        </Tooltip>
          <Divider type="vertical" />
              <Popconfirm onConfirm={e =>{deleteEmployeeToken(rowData);}} 
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Token ?'
                :  'Are you sure to Activate Token ?'
            }
          > 
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
            </Popconfirm>  
        </span>
      )
    }
  ];
  const openFormWithData = (viewData: any) => {
    console.log(viewData)
    setDrawerVisible(true);
    setSelectedToken(viewData);
  }

  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }
  // const OpenFormTocreateRecord = () => {
  //  console.log('redirect here');
   
  // }
return (
  <Card title={<span style={{color:'white'}}>Employee Tokens</span>}
  style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} 
  // extra={<Link to='/employeetokens-form'><Button className='panel_button' >Create</Button></Link>}
  extra={<Link to='/employeetokens-form' ><span style={{color:'white'}} ><Button className='panel_button' >Create </Button> </span></Link>} >
  
   <br></br>
   <Row gutter={40}>
    <Col>
        <Card title={'Total Tokens: ' + tokensData.length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#bfbfbf'}}></Card>
        </Col>
        <Col>
         <Card title={'Active: ' + tokensData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
        </Col>
        <Col>
         <Card title={'In-Active :' + tokensData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
        </Col>
        </Row>
        <br></br>
        <Table
        rowKey={record => record.qualificationId}
        columns={columnsSkelton}
        dataSource={tokensData}
        scroll = {{x:true}}
        pagination={{
          onChange(current) {
            setPage(current);
          }
        }}
        onChange={onChange}
        bordered />
        
      <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
          onClose={closeDrawer} visible={drawerVisible} closable={true}>
          <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
            <EmployeeTokens key={Date.now()}
               updateData={updateEmployeeToken}
              isUpdate={true}
              Data={selectedToken}
              closeForm={closeDrawer}
            />
          </Card>
        </Drawer>
   </Card>
);
}

export default EmployeeTokensGrid;



